var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{staticStyle:{"width":"180px"},attrs:{"options":_vm.typeList,"load-data":_vm.loadData,"placeholder":"请选择类型","change-on-select":""},on:{"change":_vm.changeType},model:{value:(_vm.typeArr),callback:function ($$v) {_vm.typeArr=$$v},expression:"typeArr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }